/* AMMO homepage rails · flip cards, media sequence, native cart adds · October 21, 2026
   QA pass October 22 (Dan's audit F01/F06/F10): native keyboard flip on both faces with focus transfer, hidden faces
   removed from the tab order (inert + tabindex), rail arrows recomputed on any resize, one script include per page.
   Scoped to [data-amh-rail]. Depends only on the SEED theme's cart drawer when present. */
(function () {
  'use strict';
  if (window.__amhInit) return; window.__amhInit = true;
  var reduceMotion = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || /[?&]amh-rm=1/.test(location.search); // ?amh-rm=1 = QA switch that mirrors the OS reduced-motion setting
  if (reduceMotion) document.documentElement.classList.add('amh-reduce-motion');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- deferred images: data-src / data-srcset → src / srcset ---------- */
  function hydrate(scope) {
    if (!scope) return;
    scope.querySelectorAll('img[data-src],img[data-srcset]').forEach(function (img) {
      if (img.dataset.srcset) { img.setAttribute('srcset', img.dataset.srcset); img.removeAttribute('data-srcset'); }
      if (img.dataset.src) { img.setAttribute('src', img.dataset.src); img.removeAttribute('data-src'); }
    });
  }

  /* ---------- rail: arrows + swipe guard ---------- */
  function initRail(rail) {
    var scroller = rail.querySelector('[data-amh-scroller]');
    if (!scroller) return;
    var prev = rail.querySelector('[data-amh-prev]'), next = rail.querySelector('[data-amh-next]');
    function step() { var card = scroller.querySelector('.amh-card'); return card ? card.getBoundingClientRect().width + 16 : 320; }
    var raf = 0;
    // Arrow state follows the real overflow: disabled only when there is nothing further in that direction
    function update() {
      if (!prev || !next) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      var none = max <= 2;
      prev.disabled = none || scroller.scrollLeft <= 2;
      next.disabled = none || scroller.scrollLeft >= max - 2;
    }
    function queueUpdate() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; update(); }); }
    if (prev) { prev.addEventListener('click', function () { scroller.scrollBy({ left: -step() * 2, behavior: reduceMotion ? 'auto' : 'smooth' }); }); }
    if (next) { next.addEventListener('click', function () { scroller.scrollBy({ left: step() * 2, behavior: reduceMotion ? 'auto' : 'smooth' }); }); }
    scroller.addEventListener('scroll', function () { scroller.dataset.scrolling = '1'; clearTimeout(scroller._t); scroller._t = setTimeout(function () { delete scroller.dataset.scrolling; update(); }, 120); }, { passive: true });
    // F06: recompute after any resize of the viewport, the container or the cards (fonts, images, editor reflows)
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(queueUpdate);
      ro.observe(scroller);
      var firstCard = scroller.querySelector('.amh-card'); if (firstCard) ro.observe(firstCard);
    }
    window.addEventListener('resize', queueUpdate);
    window.addEventListener('orientationchange', queueUpdate);
    window.addEventListener('load', queueUpdate);
    update();
    // keep the rail position across Details → Back
    var key = 'amh:' + (rail.id || rail.dataset.amhRail || '') + ':' + location.pathname;
    // restore only when the shopper comes back (browser Back from Details), never on a fresh visit
    var navType = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || {}).type;
    if (navType === 'back_forward') { try { var saved = sessionStorage.getItem(key); if (saved) scroller.scrollLeft = parseInt(saved, 10) || 0; } catch (e) {} }
    scroller.addEventListener('scroll', function () { try { sessionStorage.setItem(key, String(scroller.scrollLeft)); } catch (e) {} }, { passive: true });
    var cards = Array.prototype.slice.call(rail.querySelectorAll('.amh-card'));
    cards.forEach(function (card) { initCard(card, scroller); });
    // Page weight: cards after the second load their front images only when they come into view (plus the next one along)
    function hydrateFront(card) { if (!card || !card.hasAttribute('data-amh-gated')) return; hydrate(card.querySelector('.amh-face--front')); card.removeAttribute('data-amh-gated'); }
    // what fits on screen loads at once (2 cards on a phone, 5 on desktop); the rest wait for the row to reach them
    var eager = window.innerWidth >= 1024 ? 5 : 2;
    cards.slice(0, eager).forEach(hydrateFront);
    var gated = cards.filter(function (c) { return c.hasAttribute('data-amh-gated'); });
    if (gated.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target); hydrateFront(en.target);
            var i = cards.indexOf(en.target); if (i > -1) hydrateFront(cards[i + 1]);
          });
        }, { rootMargin: '600px 0px 600px 0px', threshold: 0.01 });
        gated.forEach(function (c) { io.observe(c); });
        window.addEventListener('load', function () {
          gated.forEach(function (c) { var r = c.getBoundingClientRect(); if (r.bottom > -600 && r.top < innerHeight + 600 && r.right > 0 && r.left < innerWidth) hydrateFront(c); });
        });
      } else { gated.forEach(hydrateFront); }
    }
  }

  /* ---------- card ---------- */
  function initCard(card, scroller) {
    var media = card.querySelector('[data-amh-media]');
    var video = card.querySelector('video');
    var flipBtn = card.querySelector('[data-amh-flip]');
    var backBtn = card.querySelector('[data-amh-flip-back]');
    var front = card.querySelector('.amh-face--front'), back = card.querySelector('.amh-face--back');
    var controls = card.querySelector('.amh-controls');
    var status = card.querySelector('[data-amh-status]');
    var progress = card.querySelector('.amh-media__progress');
    var holdTimer = null, prepared = false, backReady = false;

    // F01: the hidden face is inert (no tab stops, no clicks, hidden from assistive tech); the visible face's button is the only flip control
    function setFaces(on) {
      if (front) { front.setAttribute('aria-hidden', on ? 'true' : 'false'); if (on) front.setAttribute('inert', ''); else front.removeAttribute('inert'); }
      if (back) { back.setAttribute('aria-hidden', on ? 'false' : 'true'); if (on) back.removeAttribute('inert'); else back.setAttribute('inert', ''); }
      if (flipBtn) { flipBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); flipBtn.tabIndex = on ? -1 : 0; }
      if (backBtn) backBtn.tabIndex = on ? 0 : -1;
    }
    function setFlipped(on, moveFocus) {
      card.classList.toggle('is-flipped', on);
      setFaces(on);
      if (on) startSequence(); else stopSequence();
      if (moveFocus) { var target = on ? backBtn : flipBtn; if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } } }
    }
    function isFlipped() { return card.classList.contains('is-flipped'); }
    card.__amhClose = function () { if (isFlipped()) setFlipped(false, false); };
    setFaces(false);
    function startSequence() {
      if (!media) return;
      if (!backReady) {                       // back-face images and the poster load on the first flip
        hydrate(card.querySelector('.amh-face--back'));
        if (video && video.dataset.poster) { video.poster = video.dataset.poster; video.removeAttribute('data-poster'); }
        backReady = true;
      }
      media.classList.remove('is-done');
      if (progress) progress.style.width = '0%';
      if (video) {
        if (!prepared) {
          card.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); });
          video.load(); prepared = true;
        }
        if (reduceMotion || card.dataset.motion === 'off') { finish(); return; }
        try { video.currentTime = 0; } catch (e) {}
        clearVideoTimers();
        watchdog = setTimeout(function () { if (isFlipped() && media && !media.classList.contains('is-done') && video.currentTime < 0.25) finishIfFlipped(); }, 8000);
        var p = video.play();
        if (p && p.catch) p.catch(function () { finish(); });
      } else {
        // still image fallback: hold the application photo briefly, then show the benefits card
        var h = parseInt(card.dataset.hold, 10);
        var hold = reduceMotion ? 0 : (isNaN(h) ? 1400 : h);   // 0 = straight to the end frame (kits)
        holdTimer = setTimeout(finish, hold);
      }
    }
    function finish() { if (media) media.classList.add('is-done'); if (progress) progress.style.width = '100%'; }
    function stopSequence() {
      clearTimeout(holdTimer);
      if (typeof clearVideoTimers === 'function') clearVideoTimers();
      if (video) { try { video.pause(); video.currentTime = 0; } catch (e) {} }
      if (media) media.classList.remove('is-done');
    }
    // Fix 3 (Oct 23): a clip that fails or stalls still reaches the end frame
    var watchdog = null, stallTimer = null;
    function clearVideoTimers() { clearTimeout(watchdog); clearTimeout(stallTimer); watchdog = stallTimer = null; }
    function finishIfFlipped() { if (isFlipped()) { clearVideoTimers(); finish(); } }
    if (video) {
      card.querySelectorAll('video source').forEach(function (s) { s.addEventListener('error', finishIfFlipped); });
      video.addEventListener('stalled', function () { if (!isFlipped()) return; clearTimeout(stallTimer); stallTimer = setTimeout(finishIfFlipped, 5000); });
      video.addEventListener('waiting', function () { if (!isFlipped()) return; clearTimeout(stallTimer); stallTimer = setTimeout(finishIfFlipped, 5000); });
      ['playing', 'timeupdate'].forEach(function (t) { video.addEventListener(t, function () { clearTimeout(stallTimer); stallTimer = null; }); });
      video.addEventListener('ended', function () { clearVideoTimers(); });
      video.addEventListener('ended', finish);
      video.addEventListener('timeupdate', function () { if (progress && video.duration) progress.style.width = Math.min(100, (video.currentTime / video.duration) * 100) + '%'; });
      video.addEventListener('error', finish);
    }

    // Tap / click anywhere on the card except the controls → flip. Swipes must not flip.
    var down = null;
    card.addEventListener('pointerdown', function (e) { if (controls && controls.contains(e.target)) { down = null; return; } down = { x: e.clientX, y: e.clientY, t: Date.now() }; });
    card.addEventListener('pointerup', function (e) {
      if (!down) return; var d = down; down = null;
      if (controls && controls.contains(e.target)) return;
      if (Math.abs(e.clientX - d.x) > 8 || Math.abs(e.clientY - d.y) > 8) return;      // it was a drag/swipe
      if (scroller && scroller.dataset.scrolling) return;                               // momentum scrolling
      if (Date.now() - d.t > 700) return;                                               // long press
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      if (isFlipped()) {
        // Second tap/click on a flipped card opens the product page (Gary, Oct 22 11:30 PM). Keyboard users keep Back and Escape;
        // the card still flips back on its own when it leaves the screen.
        var url = card.dataset.url;
        if (url) { if (e.metaKey || e.ctrlKey || e.button === 1) { window.open(url, '_blank'); } else { window.location.assign(url); } }
        return;
      }
      setFlipped(true, false);
      // Oct 23 (iPhone): no focus move on a tap. iOS Safari treated the programmatic focus as keyboard focus and showed the
      // keyboard "Back" chip (and hid "Tap for details"). Keyboard users still get focus moved via Enter/Space.
    });
    card.addEventListener('pointercancel', function () { down = null; });
    // Keyboard (Enter/Space fire click with detail 0): front button opens and moves focus to the visible Back control;
    // Back button closes and returns focus to the front control. Mouse clicks are handled by pointerup above.
    if (flipBtn) flipBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (e.detail === 0 && !isFlipped()) setFlipped(true, true); });
    if (backBtn) backBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (e.detail === 0 && isFlipped()) setFlipped(false, true); });
    card.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isFlipped()) { e.preventDefault(); setFlipped(false, true); } });
    // Controls never bubble into the flip
    if (controls) { ['pointerdown', 'pointerup', 'click', 'touchstart'].forEach(function (t) { controls.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: t !== 'click' }); }); }
    // Pause offscreen (no focus move: the shopper scrolled away)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (!en.isIntersecting && isFlipped()) setFlipped(false, false); }); }, { threshold: 0.05 }).observe(card);
    }
    // Add to cart
    var form = card.querySelector('form[data-amh-add]');
    if (form) form.addEventListener('submit', function (e) { addToCart(e, form, card, status); });
  }

  /* ---------- cart ---------- */
  function showStatus(status, text, isError) {
    if (!status) return;
    status.textContent = text; status.dataset.error = isError ? 'true' : 'false'; status.classList.add('is-shown');
    clearTimeout(status._t); if (!isError) status._t = setTimeout(function () { status.classList.remove('is-shown'); }, 2600);
  }
  function addToCart(event, form, card, status) {
    if (!window.fetch || !window.FormData) return; // native POST fallback
    event.preventDefault();
    var button = form.querySelector('[data-amh-add-btn]');
    if (!button || button.disabled || form.dataset.busy === '1') return;
    var label = button.querySelector('span');
    var original = label ? label.textContent : '';
    form.dataset.busy = '1'; button.classList.add('is-busy'); if (label) label.textContent = 'Adding…';
    var cart = document.querySelector('cart-drawer');
    var drawer = document.querySelector('#CartDrawer');
    var data = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      try { data.append('sections', cart.getSectionsToRender().map(function (x) { return x.id || x.section; }).join(',')); data.append('sections_url', location.pathname); } catch (e) {}
    }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        var j = res.json;
        if (!res.ok || j.status) { var err = new Error(j.description || j.message || 'This item could not be added.'); err.confirmed = true; throw err; }
        showStatus(status, 'Added to your cart.', false);
        if (label) label.textContent = 'Added'; button.classList.add('is-ok');
        setTimeout(function () { if (label) label.textContent = original; button.classList.remove('is-ok'); }, 1800);
        card.dispatchEvent(new CustomEvent('amh:added', { bubbles: true, detail: j }));
        // Native drawer refresh. A confirmed add is never retried if the drawer fails to render.
        try {
          if (window.theme && window.theme.utils && window.theme.utils.subscriptions && window.PUB_SUB_EVENTS) {
            window.theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ammo-home', productVariantId: data.get('id') });
          }
          if (cart && cart.renderContents && j.sections) { cart.renderContents(j); if (drawer && drawer.open) drawer.open(); }
          else { refreshCount(); if (drawer && drawer.open) drawer.open(); }
        } catch (e) { refreshCount(); }
      })
      .catch(function (err) {
        showStatus(status, err.confirmed ? err.message : 'We could not confirm the addition. Check your cart before trying again.', true);
      })
      .then(function () { form.dataset.busy = '0'; button.classList.remove('is-busy'); if (label && label.textContent === 'Adding…') label.textContent = original; });
  }
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var el = document.getElementById('cart-count'); if (!el) return;
      var n = c.item_count || 0; el.textContent = (n > 0 && n < 10 ? '0' : '') + n;
    }).catch(function () {});
  }

  // Oct 23: the NEW chip's end date is checked in Liquid; this hides it too if a cached page is served after that date
  function expireNew() { var now = Date.now() / 1000; document.querySelectorAll('[data-amh-new-until]').forEach(function (el) { if (now >= +el.dataset.amhNewUntil) el.parentNode.classList.add('is-expired'); }); }
  function boot() { document.querySelectorAll('[data-amh-rail]').forEach(function (rail) { if (!rail.dataset.amhReady) { rail.dataset.amhReady = '1'; initRail(rail); } }); expireNew(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Oct 23: Back from a product page restores the page from Safari's/Chrome's back-forward cache with the card still flipped and
  // its clip frozen; close any flipped card so the rail comes back clean.
  window.addEventListener('pageshow', function (e) { if (!e.persisted) return; document.querySelectorAll('.amh-card.is-flipped').forEach(function (c) { if (c.__amhClose) c.__amhClose(); }); });
  document.addEventListener('shopify:section:load', boot);
})();
